export const DELETE_VIDEO = 'Slet video';